import maximize from './actions/Maximize/texts.js';

export default {
  action: {
    maximize,
  },
};
